import { render, staticRenderFns } from "./strictBox.vue?vue&type=template&id=7fde81d6&scoped=true"
import script from "./strictBox.vue?vue&type=script&lang=js"
export * from "./strictBox.vue?vue&type=script&lang=js"
import style0 from "./strictBox.vue?vue&type=style&index=0&id=7fde81d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde81d6",
  null
  
)

export default component.exports